import { render, staticRenderFns } from "./crudPHPCode.vue?vue&type=template&id=553d44a1&scoped=true&"
import script from "./crudPHPCode.vue?vue&type=script&lang=js&"
export * from "./crudPHPCode.vue?vue&type=script&lang=js&"
import style0 from "./crudPHPCode.vue?vue&type=style&index=0&id=553d44a1&scoped=true&lang=css&"
import style1 from "./crudPHPCode.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553d44a1",
  null
  
)

export default component.exports